export const NewFormModalTestIDs = {
  nameInput: "new-form-name-input",
  descriptionInput: "new-form-description-input",
  submitButton: "new-form-submit-button",
};
